<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Cabinet Features</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (drainPanSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Drain Pan:</label>
            <select class="halfWidthInputField" #drainPanInput
              [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
              (change)="selectionChanged(drainPanSelection, drainPanInput.value)"
              [value]="drainPanSelection.Value.toString()">
              @for (allowable of drainPanSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (cabinetInsulationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Cabinet Insulation:</label>
            <select class="halfWidthInputField" #cabinetInsulationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetInsulationSelection.Name)"
              (change)="selectionChanged(cabinetInsulationSelection, cabinetInsulationInput.value)"
              [value]="cabinetInsulationSelection.Value.toString()">
              @for (allowable of cabinetInsulationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetInsulationSelection.Value && cabinetInsulationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
